/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 11/29/2016
 * Time: 6:58 PM
 */

/**
 * Widget for customizing print page
 */
(function($) {
    $.widget('ca.caPrint', {
        options: {
            redirectLink: '',
            onAfterPrint: function () {
                var self = this;

                // Chrome issues:
                // https://code.google.com/p/chromium/issues/detail?id=363392
                // http://blog.innovsystems.com/javascript/windowprint-and-windowclose-issue-chrome
                //
                setTimeout(function () {
                    if (window.opener) {
                        window.close();
                    } else if (self.redirectLink) {
                        window.location = self.redirectLink;
                    }
                }, 1000);
            }
        },

        _create: function () {
            var self = this;

            if (navigator.appName == 'Microsoft Internet Explorer') {
                var PrintCommand = '<OBJECT ID="PrintCommandObject" WIDTH=0 HEIGHT=0 ';
                PrintCommand += 'CLASSID="CLSID:8856F961-340A-11D0-A96B-00C04FD705A2"></OBJECT>';
                document.body.insertAdjacentHTML('beforeEnd', PrintCommand);
                PrintCommandObject.ExecWB(6, 2);
                PrintCommandObject.outerHTML = '';
                this.options.onAfterPrint();
            } else if (window.jsPrintSetup) {
                this.doPrint();

                if (jsPrintSetup.getPermissions() == jsPrintSetup.JSPS_ALLOW_ACTION) {
                    this.options.onAfterPrint();
                } else {
                    jsPrintSetup.setCallback({
                        permissionsAsk: function (allowed) {
                            if (allowed) {
                                self.doPrint();
                                self.options.onAfterPrint();
                            }
                        }
                    });
                }
            } else if (window.print) {
                window.print();
                this.options.onAfterPrint();
            }
        },

        doPrint: function () {
            jsPrintSetup.setOption('headerStrLeft', '');
            jsPrintSetup.setOption('headerStrCenter', '');
            jsPrintSetup.setOption('headerStrRight', '');
            jsPrintSetup.setOption('footerStrLeft', '');
            jsPrintSetup.setOption('footerStrCenter', '');
            jsPrintSetup.setOption('footerStrRight', '');

            jsPrintSetup.setOption('printSilent', 1);
            jsPrintSetup.print();
        }
    });
})(jQuery);
